import store from '@/store/store';
import moment from 'moment';

function getGrilleTarifaire(critere) {
  const societeActive = store.getters['societe/societeActive'];
  const produit  = societeActive.produitFraisTechnique;

  if (!produit || !produit.grilleTarifaires || !produit.grilleTarifaires.length) return null;

  const gts = produit.grilleTarifaires.filter(t => {
    return t.actif
      && moment(t.dateDebut).isSameOrBefore(critere.dateVisu)
      && (!t.dateFin || moment(critere.dateVisu).isSameOrBefore(t.dateFin));
  });
  const matchProduitFace = t => !!t.produitFaceId && t.produitFaceId === critere.produitFaceId;
  // une grille sur le produit face est prioritaire sur toutes les autres
  const cascade = [
    t => matchProduitFace(t) && t.formatId === critere.formatId && t.tiersId === critere.enseigneId,
    t => matchProduitFace(t) && t.tiersId === critere.enseigneId && !t.formatId,
    t => matchProduitFace(t) && !t.tiersId && t.formatId === critere.formatId,
    t => matchProduitFace(t) && !t.tiersId && !t.formatId,
    t => !t.produitFaceId && t.formatId === critere.formatId && t.tiersId === critere.enseigneId,
    t => !t.produitFaceId && t.tiersId === critere.enseigneId && !t.formatId,
    t => !t.produitFaceId && !t.tiersId && t.formatId === critere.formatId,
    t => !t.produitFaceId && !t.tiersId && !t.formatId,
  ];
  for (let i = 0; i < cascade.length; i += 1) {
    const gt = gts.find(cascade[i]);
    if (gt) return gt;
  }
  return null;
}

export function getTarif(critere, budget) {
  if (!critere) return;
  if (budget.dateDebut) critere.dateVisu = budget.dateDebut;
  const gt = getGrilleTarifaire(critere);
  if (!gt) return;
  const qte = gt.quantite ? gt.quantite : 0;
  const pu = gt.prixUnitaire ? gt.prixUnitaire : 0;
  budget.fraisTechnique = qte * pu;
}
